/**
 * 获取当前运行环境
 * @returns
 */
function getContextType() {
  if (typeof window?.webview === 'object') {
    return 'appWebView'
  } else if (window) {
    return 'browser'
  } else {
    return 'unknown'
  }
}

/**
 * 根据不同的运行环境，获取永久存储
 * @param key
 * @returns
 */
function getLocalStorage(key: string, isParse = false) {
  const contextType = getContextType()
  let value
  if (contextType === 'browser') {
    value = localStorage.getItem(key)
  } else if (contextType === 'appWebView') {
    value = window.webview?.getLocalStorage(key)
  } else {
    value = ''
  }

  if (isParse && value) {
    return JSON.parse(value)
  }
  return value
}

/**
 * 根据不同的运行环境，设置永久存储
 * @param key
 * @returns
 */
function setLocalStorage(key: string, value: any) {
  const contextType = getContextType()
  if (typeof value !== 'string') {
    value = JSON.stringify(value)
  }
  if (contextType === 'browser') {
    localStorage.setItem(key, value)
  } else if (contextType === 'appWebView') {
    window.webview?.setLocalStorage(key, value)
  }
}

/**
 * 根据不同的运行环境，移除某一项存储
 * @param key
 */
function removeLocalStorage(key: string) {
  const contextType = getContextType()
  if (contextType === 'browser') {
    localStorage.removeItem(key)
  } else if (contextType === 'appWebView') {
    window.webview?.setLocalStorage(key, null)
  }
}

export default {
  getContextType,
  getLocalStorage,
  setLocalStorage,
  removeLocalStorage,
}
